export const PLANITY_URL = "https://www.planity.com/maison-ria-95100-argenteuil";
export const GOOGLE_REVIEWS_URL = "https://g.page/r/Cf0P3yeapZ3wEBM/review";
export const INSTAGRAM_URL = "https://www.instagram.com/maison.ria";

export const CONTACT = {
  email: "riaparis@outlook.fr",
  phone: "06 62 11 50 00",
  phoneRaw: "+33662115000",
  address: "30 rue de Saussure, 75017 Paris",
};

export const eur = (n) =>
  `${Number(n) % 1 ? Number(n).toFixed(2).replace(".", ",") : n} €`;

export const IMAGES = {
  portraitR: "/brand/portrait-r.png",
  portraitLogo: "/brand/maison-visage.png",
  fidelite: "/brand/fidelite-visage.png",
  studioInterior: "/brand/fauteuil.jpg",
  academy: "/brand/banc.jpg",
  resultsMacro:
    "https://images.unsplash.com/photo-1651839633408-3fccd671b832?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxwZXJmZWN0JTIwbWljcm9ibGFkZWQlMjBleWVicm93cyUyMGNsb3NlJTIwdXB8ZW58MHx8fHwxNzkwNzAxMTkyfDA&ixlib=rb-4.1.0&q=85",
};

const RETOUCHES_NOTE =
  "3–6 mois : 90 € · 6–12 mois : 130 € · 12–18 mois : 160 € · 18–24 mois : 180 € · au-delà de 24 mois : sur devis. Réservées aux clientes du studio.";

export const PRESTATION_GROUPS = [
  {
    id: "diagnostic",
    title: "Diagnostic — Pour commencer",
    items: [
      {
        id: "diagnostic",
        name: "Diagnostic & Consultation Sur-Mesure",
        duration: "30 min",
        price: "30 €",
        desc: "Pour sourcils, lèvres, cuir chevelu ou peau — facultatif. Analyse globale de la morphologie du visage et de la zone à traiter, étude personnalisée de vos attentes et orientation vers la technique la plus adaptée. Un premier échange à distance, par écrit, reste toujours offert.",
      },
    ],
  },
  {
    id: "sourcils-mp",
    title: "Sourcils — Maquillage permanent",
    items: [
      {
        id: "nanoblading",
        name: "Nanoblading / Microblading",
        duration: "1 h 30",
        price: "320 €",
        desc: "Redessine les sourcils avec une extrême précision grâce à une technique ultra-fine, pour un rendu léger et aérien — invisible. Une retouche est à prévoir un mois plus tard.",
      },
      {
        id: "hairstroke",
        name: "Hairstroke (hyperréalisme)",
        duration: "3 h",
        price: "390 €",
        desc: "Restructure les sourcils avec un rendu hyperréaliste et un effet 3D qui simule les vrais poils.",
      },
      {
        id: "retouche-fixatrice-sourcils",
        name: "Retouche Fixatrice (1 mois)",
        duration: "1 h",
        price: "50 €",
        desc: "Fixe durablement la pigmentation qui s'estompe après la première séance. À réaliser dans un délai de 4 à 6 semaines.",
      },
      {
        id: "retouche-entretien-sourcils",
        name: "Retouche d'Entretien",
        duration: "1 h 30",
        price: "de 90 à 180 €",
        desc: "Pour raviver une pigmentation existante.",
        note: RETOUCHES_NOTE,
      },
    ],
  },
  {
    id: "levres-mp",
    title: "Lèvres — Maquillage permanent",
    items: [
      {
        id: "lip-blush",
        name: "Lip Blush",
        duration: "1 h 30",
        price: "280 €",
        desc: "Rehausse la teinte naturelle des lèvres, corrige les petites asymétries et redessine le contour pour un effet frais et harmonieux. Une retouche est à prévoir deux mois plus tard.",
      },
      {
        id: "retouche-fixatrice-levres",
        name: "Retouche Fixatrice (2 mois)",
        duration: "1 h",
        price: "60 €",
        desc: "Fixe durablement la couleur et révèle le résultat final. À réaliser dans un délai de 8 à 10 semaines après la création.",
      },
      {
        id: "retouche-entretien-levres",
        name: "Retouche d'Entretien",
        duration: "1 h 30",
        price: "de 90 à 180 €",
        desc: "Pour raviver la teinte dans la durée.",
        note: RETOUCHES_NOTE,
      },
    ],
  },
  {
    id: "visage-mp",
    title: "Visage — Maquillage permanent",
    items: [
      {
        id: "taches-de-rousseur",
        name: "Tâches de rousseur",
        duration: "1 h",
        price: "dès 90 €",
        desc: "Un effet sun-kissed délicat et naturel, pour un rendu frais, lumineux et sur-mesure.",
        note: "Small (nez) : 90 € · Medium (nez et pommettes) : 130 € · Large (nez, pommettes, tempes, joues, front) : 180 €.",
      },
      {
        id: "retouche-taches",
        name: "Retouche Fixatrice (1 mois)",
        duration: "45 min",
        price: "50 €",
        desc: "Ajoute de nouvelles taches et crée des superpositions pour un résultat fondu et ultra naturel.",
      },
      {
        id: "grain-de-beaute",
        name: "Grain de beauté (visage ou corps)",
        duration: "30 min",
        price: "40 €",
        desc: "Recrée un détail subtil et élégant, placé avec précision pour mettre en valeur les traits.",
      },
      {
        id: "coeur-de-beaute",
        name: "Cœur de beauté (visage ou corps)",
        duration: "30 min",
        price: "60 €",
        desc: "Pigmentation artistique et délicate en forme de cœur — un détail unique qui reste naturel.",
      },
    ],
  },
  {
    id: "sourcils-soins",
    title: "Sourcils — Soins & restructuration",
    items: [
      {
        id: "browlift",
        name: "Browlift (avec ou sans teinture)",
        duration: "1 h",
        price: "70 €",
        desc: "Discipline et restructure les poils pour un effet sourcils coiffés, naturel et élégant, pendant plusieurs semaines. Teinture en supplément : +10 €.",
      },
      {
        id: "restructuration",
        name: "Restructuration (épilation)",
        duration: "45 min",
        price: "30 €",
        desc: "Première épilation à la pince après définition de la forme, de l'épaisseur et de la ligne adaptées à la morphologie de votre visage.",
      },
      {
        id: "entretien-epilation",
        name: "Entretien (épilation)",
        duration: "30 min",
        price: "20 €",
        desc: "Entretien régulier de la restructuration, réalisable jusqu'à 6 semaines après celle-ci.",
      },
    ],
  },
  {
    id: "tricopigmentation",
    title: "Cuir chevelu — Tricopigmentation",
    items: [
      {
        id: "trico-rase",
        name: "Tricopigmentation — effet rasé",
        duration: "3 h",
        price: "Sur devis",
        devis: true,
        desc: "Imite l'apparence des follicules pour un rendu visuel de crâne fraîchement rasé — bluffant de naturel.",
      },
      {
        id: "trico-densite",
        name: "Tricopigmentation — effet densité",
        duration: "3 h",
        price: "Sur devis",
        devis: true,
        desc: "Crée une illusion d'épaisseur entre les cheveux existants, idéale pour les chevelures clairsemées.",
      },
      {
        id: "trico-cicatrices",
        name: "Tricopigmentation — camouflage cicatrices",
        duration: "3 h",
        price: "Sur devis",
        devis: true,
        desc: "Fond la zone marquée dans la chevelure de manière discrète et uniforme, en parfaite harmonie avec votre cuir chevelu.",
      },
    ],
  },
  {
    id: "glow",
    title: "Glow — Soins avancés de la peau",
    items: [
      {
        id: "nanoneedling",
        name: "Nanoneedling / Microneedling",
        duration: "45 min",
        price: "120 €",
        desc: "Booste l'efficacité des actifs et stimule le renouvellement cellulaire pour une peau plus lisse, éclatante et revitalisée.",
      },
      {
        id: "cure-4",
        name: "Cure de 4 séances — Nanoneedling / Microneedling",
        duration: "1 h / séance",
        price: "400 €",
        desc: "Séances espacées de 15 jours — la séance revient à 100 € au lieu de 120 €.",
      },
      {
        id: "cure-6",
        name: "Cure de 6 séances — Nanoneedling / Microneedling",
        duration: "1 h / séance",
        price: "570 €",
        desc: "Séances espacées de 15 jours — la séance revient à 95 € au lieu de 120 €.",
      },
      {
        id: "skin-repair-cicatrices",
        name: "Skin Repair (cicatrices)",
        duration: "1 h 30",
        price: "dès 180 €",
        desc: "Atténue l'apparence des marques : la peau se régénère progressivement et retrouve souplesse et homogénéité. 3 à 6 séances nécessaires.",
        note: "Petite taille : 180 € · Moyenne taille : 210 € · Grande taille : 250 €.",
      },
      {
        id: "skin-repair-vergetures",
        name: "Skin Repair (vergetures)",
        duration: "1 h 30",
        price: "dès 180 €",
        desc: "Améliore l'aspect des vergetures et la texture de la peau, pour un rendu naturel et harmonieux — 180 € par zone.",
      },
    ],
  },
];

export const PRESENTIEL_INCLUDES = [
  "Formation individuelle en one-to-one",
  "Pratique sur modèle réel",
  "Certificat Maison Ria",
  "Liste de matériel offerte",
  "Bonus : module communication & réseaux sociaux offert",
];

export const FORMATIONS_PRESENTIEL = [
  {
    id: "f-nanoblading",
    name: "Formation Nanoblading",
    duration: "2 jours au studio",
    price: 1900,
    suivi: "Suivi 12 mois",
  },
  {
    id: "f-masterclass",
    name: "Masterclass Nanoblading + Microblading + Shading",
    duration: "3 jours au studio",
    price: 2500,
    suivi: "Suivi 12 mois",
  },
  {
    id: "f-freckles",
    name: "Formation Tâches de Rousseur",
    duration: "1 jour au studio",
    price: 800,
    suivi: "Suivi 12 mois",
  },
  {
    id: "f-tricopigmentation",
    name: "Formation Tricopigmentation",
    duration: "2 jours au studio",
    price: 2200,
    suivi: "Suivi 12 mois",
  },
  {
    id: "f-browlift",
    name: "Formation Browlift",
    duration: "1 jour au studio",
    price: 390,
    suivi: "Suivi 12 mois",
  },
  {
    id: "f-mapping",
    name: "Formation Mapping & Restructuration",
    duration: "Demi-journée au studio",
    price: 190,
    suivi: "Suivi 12 mois",
  },
];

export const FORMATIONS_DISTANCIEL = [
  {
    id: "d-ebook-mapping",
    name: "E-book Mapping",
    duration: "E-book · téléchargement immédiat",
    price: 0,
    desc: "Le guide offert de la construction de la ligne : repères, mesures et symétrie expliqués pas à pas.",
  },
  {
    id: "d-mapping-video",
    name: "Mapping — Formation vidéo",
    duration: "Formation vidéo · accès continu",
    price: 47,
    desc: "La technique du mapping filmée en détail : apprenez à tracer une ligne parfaite avant toute prestation.",
  },
  {
    id: "d-reseaux",
    name: "Objectif Agenda Complet",
    duration: "Formation vidéo · à votre rythme",
    price: 197,
    desc: "Image de marque et réseaux sociaux : la méthode pour transformer vos abonnés en clientes et remplir votre planning.",
  },
  {
    id: "d-nanoblading",
    name: "Nanoblading",
    duration: "Formation vidéo · accès continu",
    price: 590,
    desc: "Toute la technique du tracé ultra-fin : morphologie, gestuelle, colorimétrie et protocoles.",
  },
  {
    id: "d-trio",
    name: "Nanoblading + Microblading + Shading",
    duration: "Formation vidéo · accès continu",
    price: 890,
    desc: "Le triptyque complet de la dermopigmentation des sourcils, du poil à poil à l'effet poudré.",
  },
  {
    id: "d-browlift",
    name: "Browlift",
    duration: "Formation vidéo · accès continu",
    price: 197,
    desc: "La prestation d'entrée de gamme idéale : protocole complet, produits et gestuelle filmés.",
  },
];

export const AVIS = [
  {
    name: "Vanessa A.",
    location: null,
    text: "Je suis trop contente du résultat de mon nanoblading avec Oriane ! Elle a été super à l'écoute du début à la fin, très douce et surtout hyper rassurante. Elle prend vraiment le temps d'expliquer chaque étape et de s'assurer qu'on est à l'aise et qu'on aime le résultat. Le résultat est juste ouf, exactement ce que je voulais : naturel, précis et parfaitement adapté à mon visage. Je recommande Oriane les yeux fermés ! Merci encore pour ton travail et ta gentillesse.",
    source: "Avis vérifié",
  },
  {
    name: "Justine V.",
    location: null,
    text: "Mille mercis à Oriane pour son travail exceptionnel sur mes sourcils (nanoblading). Le rendu est tellement subtil et naturel que j'ai encore du mal à y croire. Très heureuse d'être enfin tombée sur la bonne personne qui a su répondre 100 % à mes attentes. Elle prend le temps d'être à votre disposition, de répondre à vos questions, et d'expliquer chaque étape du processus pour vous rassurer au maximum. Vous pouvez lui faire confiance les yeux fermés !",
    source: "Avis vérifié",
  },
  {
    name: "Laura D.",
    location: "Paris",
    text: "Un énorme merci à Oriane pour son travail ! Après 3 ans d'hésitation (par peur du résultat) j'ai sauté le pas sur les bons conseils d'une amie. Le seul regret c'est d'avoir attendu si longtemps ! Si seulement tous les complexes pouvaient être gommés aussi parfaitement et surtout avec autant de douceur et de bienveillance. Quel plaisir de ne plus avoir à maquiller mes sourcils tous les matins !",
    source: "Avis vérifié",
  },
  {
    name: "Marine I.",
    location: null,
    text: "Oriane c'est la petite fée qui sublime tout ! D'une douceur incroyable, à l'écoute, elle m'a mise en confiance tout simplement. Je laisse mon commentaire après ma retouche et je suis ravie du résultat ! Le studio est tout mimi, propre, très bien situé proche des transports et facile d'accès ! Oriane explique chaque étape pendant son travail ce qui rassure énormément. Ravie d'avoir trouvé cette pro du brow, je recommande +++. Merci Oriane !",
    source: "Avis vérifié",
  },
  {
    name: "Laura B.",
    location: null,
    text: "Je laisse un avis après mon second rendez-vous avec Maison Ria, suite à ma retouche. Le travail est exceptionnel, précis, doux et très bien pensé. Oriane est très à l'écoute, agréable et professionnelle. Le résultat est magnifiquement naturel et digne des meilleurs instituts spécialisés de Paris, voire meilleur. Je conseille fortement Maison Ria à quiconque !",
    source: "Avis vérifié",
  },
];

export const SCORES_PLANITY = [
  { label: "Accueil", value: "5,0" },
  { label: "Propreté", value: "5,0" },
  { label: "Cadre & Ambiance", value: "5,0" },
  { label: "Qualité de la prestation", value: "5,0" },
];

export const LEGAL = {
  mentions: {
    title: "Mentions légales",
    sections: [
      {
        heading: "Éditrice du site",
        paragraphs: [
          "Le site est édité par Maison Ria — Oriane, entrepreneure individuelle, dont le studio est situé au 30 rue de Saussure, 75017 Paris.",
          "Contact : riaparis@outlook.fr — 06 62 11 50 00. Numéro SIREN : 900 359 555. TVA non applicable, article 293 B du Code général des impôts.",
          "Directrice de la publication : Oriane, fondatrice de Maison Ria.",
        ],
      },
      {
        heading: "Hébergement",
        paragraphs: [
          "Le site est hébergé par un prestataire professionnel garantissant la sécurité et la disponibilité des données. Les coordonnées complètes de l'hébergeur sont communiquées sur demande à riaparis@outlook.fr.",
        ],
      },
      {
        heading: "Propriété intellectuelle",
        paragraphs: [
          "L'ensemble des contenus du site (logotype, monogramme, textes, photographies, mise en page) est la propriété exclusive de Maison Ria, sauf mention contraire. Toute reproduction, représentation ou utilisation, totale ou partielle, sans autorisation écrite préalable est interdite.",
        ],
      },
      {
        heading: "Données personnelles",
        paragraphs: [
          "Les traitements de données personnelles réalisés depuis ce site sont décrits dans la page « Confidentialité », accessible depuis le pied de page.",
        ],
      },
    ],
  },
  cgv: {
    title: "Conditions générales de vente",
    sections: [
      {
        heading: "1. Objet",
        paragraphs: [
          "Les présentes conditions définissent les modalités de réservation des prestations Maison Ria (dermopigmentation, soins et formations), réalisées via notre partenaire Planity ou par contact direct.",
        ],
      },
      {
        heading: "2. Prestations et tarifs",
        paragraphs: [
          "Les prestations, durées et tarifs sont ceux affichés sur la page « Le Studio » au jour de la réservation. Les prix sont exprimés en euros, toutes taxes comprises — TVA non applicable, article 293 B du CGI. Certaines prestations (tricopigmentation, retouches au-delà de 24 mois) font l'objet d'un devis personnalisé.",
        ],
      },
      {
        heading: "3. Réservation et annulation",
        paragraphs: [
          "La réservation s'effectue en ligne via Planity avec confirmation immédiate. Toute annulation ou modification doit intervenir au minimum 24 heures à l'avance ; passé ce délai, la séance est due à 100 %, le créneau étant réservé exclusivement pour vous.",
        ],
      },
      {
        heading: "4. Contre-indications et préparation",
        paragraphs: [
          "Les contre-indications (grossesse, traitements médicamenteux, maladies de peau, etc.) et les consignes de préparation sont détaillées sur la page « Le Studio » et doivent être lues avant toute réservation. En cas de doute, demandez un avis médical. Maison Ria se réserve le droit de refuser une prestation en cas de contre-indication avérée, pour votre sécurité.",
        ],
      },
      {
        heading: "5. Formations",
        paragraphs: [
          "Toute inscription à une formation de l'Académie (présentiel ou en ligne) fait l'objet d'un échange préalable et d'une convention. Les formations en présentiel sont individuelles (one-to-one) et comprennent la pratique sur modèle réel, le certificat Maison Ria et le suivi indiqué sur la page « L'Académie ». Les formations en ligne sont délivrées en format vidéo, accompagnées de documents et d'e-books.",
        ],
      },
      {
        heading: "6. Paiement",
        paragraphs: [
          "Les règlements au studio s'effectuent en espèces, par PayPal ou par virement instantané. Les retouches sont réservées aux clientes ayant réalisé leur pigmentation initiale au studio.",
        ],
      },
      {
        heading: "7. Litiges",
        paragraphs: [
          "En cas de litige, contactez-nous en priorité à riaparis@outlook.fr afin de trouver une solution amiable. À défaut, vous pouvez saisir gratuitement le médiateur de la consommation compétent. Les présentes conditions sont soumises au droit français.",
        ],
      },
    ],
  },
  confidentialite: {
    title: "Politique de confidentialité",
    sections: [
      {
        heading: "Responsable de traitement",
        paragraphs: [
          "Maison Ria — Oriane, entrepreneure individuelle, 30 rue de Saussure, 75017 Paris — riaparis@outlook.fr.",
        ],
      },
      {
        heading: "Données collectées",
        paragraphs: [
          "Candidatures de l'Académie : identité, e-mail, téléphone et message, utilisés uniquement pour étudier votre candidature et vous recontacter.",
          "Réservations : les données saisies lors d'une réservation sont traitées par Planity, notre partenaire de réservation, selon sa propre politique de confidentialité.",
          "Ces données ne font l'objet d'aucune vente ni transmission à des tiers à des fins commerciales.",
        ],
      },
      {
        heading: "Durées de conservation",
        paragraphs: [
          "Les candidatures sont conservées 12 mois, puis supprimées. Les échanges par e-mail sont conservés le temps de traiter votre demande.",
        ],
      },
      {
        heading: "Vos droits",
        paragraphs: [
          "Conformément au RGPD et à la loi Informatique et Libertés, vous disposez de droits d'accès, de rectification, d'effacement, d'opposition et de portabilité sur vos données. Écrivez à riaparis@outlook.fr ; une réponse vous est apportée sous 30 jours. Vous pouvez également saisir la CNIL (cnil.fr) en cas de désaccord.",
        ],
      },
      {
        heading: "Cookies",
        paragraphs: [
          "Le site n'utilise pas de cookie publicitaire ni de traceur tiers. Seules les données techniques strictement nécessaires à votre navigation sont utilisées.",
        ],
      },
    ],
  },
};
